import React from 'react';

import ReceiptsModule from '../receipts/components/ReceiptsModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryReceiptsModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.receipt', action: 'read' },
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <ReceiptsModule />
    </InventoryPermissionGuard>
  );
}